export type EnquiryData = {
    _id?: string;
    dateOfEnquiry?: string;
    institutionName?: string;
    enquiryPurpose?: string;
    enquiryAmount?: string;
    tenure?: string;
    directorId?: string;
    assesseeId?: string;
};

export type BureauEnquiryTableProps = {
    data: EnquiryData[];
    loading: boolean;
    vendorType: VendorType;
};

export type VendorType = 'EQUIFAX' | 'EXPERIAN';

export const NEW_TO_CREDIT_THRESHOLD = 100;
